import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import {
	type ResourceStoreContext,
	type RouteResource,
	type RouterDataContext,
	type UseResourceHookResponse,
	createResource,
	useResource,
} from '@atlassian/react-resource-router';
import { fetchWorkflowDocument } from './fetchWorkflowDocument.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_DOCUMENT';

export const workflowDocumentResource: RouteResource<ApiGetWorkflowResponseWithUsages> =
	createResource<ApiGetWorkflowResponseWithUsages>({
		type: RESOURCE_TYPE_KEY,
		getKey: (matchedRoute) => {
			const { workflowId, projectKey, issueTypeId } = matchedRoute.match.params;
			if (workflowId) {
				return `${RESOURCE_TYPE_KEY}_${workflowId}`;
			}
			return `${RESOURCE_TYPE_KEY}_${projectKey}_${issueTypeId}`;
		},
		getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
			fetchWorkflowDocument(routerContext, customContext, false),
		maxAge: 0,
		isBrowserOnly: true,
	});

export const useWorkflowDocument = (): UseResourceHookResponse<ApiGetWorkflowResponseWithUsages> =>
	useResource<ApiGetWorkflowResponseWithUsages>(workflowDocumentResource);
